import FormFooter from '@/components/footers/FormFooter';
import { ModuleFormFooterFragment } from '@/graphql';
import { parseHtml } from '@/lib/parse-html';
import { FC, PropsWithChildren } from 'react';

interface FormFooterModuleProps extends PropsWithChildren {
  props: CraftModuleFragment<ModuleFormFooterFragment>;
}

const FormFooterModule: FC<FormFooterModuleProps> = ({ props, children }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return (
    <FormFooter heading={props.heading ?? ''} text={parseHtml(props.text)} background={props.background ?? undefined}>
      {children}
    </FormFooter>
  );
};

export default FormFooterModule;
